import React from "react";
import PaidEstimateContent from "../content/paidEstimateContent";
import Layout from "../layout/Layout";

function PaidEstimate() {
  return (
    <Layout>
      <PaidEstimateContent />
    </Layout>
  );
}

export default PaidEstimate;
